import { render, staticRenderFns } from "./product-supliers-tab.vue?vue&type=template&id=def65d32&"
import script from "./product-supliers-tab.vue?vue&type=script&lang=js&"
export * from "./product-supliers-tab.vue?vue&type=script&lang=js&"
import style0 from "./product-supliers-tab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports